import React, {useState} from "react";
import { Layout, Row, Column } from "../Layout/Layout";
import Flickity from 'react-flickity-component'

import "./AboutPage.css";

const flickityOptions = {
    initialIndex: 2,
    wrapAround: true,
    pageDots: false,
    arrowShape: { 
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
    }

}

const AboutPage = () => {
    return(
        <div>
            <header className="bg-grey">
                <Layout>
                    <Row align="align-center">
                        <Column className="header--text-container">
                            <div className="header--text">
                                <h1 className="yellow">About Us</h1>
                                <h2 className="yellow">
                                We believe you deserve nothing less than the best. That's why we stay ahead of the curve, continually updating our techniques, technologies, and standards to bring modern solutions and time-tested expertise to every project we work on.
                                </h2>
                            </div>
                        </Column>
                        <Column className="services-content--image-container" flex="true" justify="justify-end" align="align-center">
                            <div className="about-content--header-image">
                                <img src="/assets/About-Us.jpg" />
                            </div>
                        </Column>
                    </Row>
                </Layout>
            </header>
            <div className="about-content">
                <Layout>
                    <Row align="align-start">
                        <Column className="about--section-title">
                            <h4 className="service-countdown"><span className="short-line" /> About Us</h4>
                        </Column>
                        <Column className="about--section-title">
                            <p className="about-content--about-text">
                                With over 30 years of experience, Vue Electric has built a reputation as the
                                premier electrical contractor on Long Island&apos;s East End. We proudly serve
                                all areas of the Hamptons, Shelter Island, the North Fork, and throughout Suffolk
                                County, bringing the same level of craftsmanship and care to every project we
                                take on.
                            </p>
                            <p className="about-content--about-text">
                                We specialize in a comprehensive range of residential and commercial electrical
                                services, including new construction, renovations, landscape lighting, lighting
                                design, underground fault detection and repair, and non-invasive directional
                                drilling. Our team also offers expert design consulting for projects that demand a
                                higher level of industry knowledge.
                            </p>
                            <p className="about-content--about-text">
                                At Vue Electric, our clients are at the center of everything we do. We work
                                tirelessly to deliver results that are safe, reliable, and built to last, because
                                when it comes to your home or business, the details matter. That dedication is what
                                has made us a trusted name on Long Island for decades, and it&apos;s what
                                continues to drive us every day.
                            </p>
                            <p className="about-content--about-text">
                                <em>Enhancing your Vue, one project at a time.</em>
                            </p>
                        </Column>
                    </Row>
                </Layout>
            </div>
            <div className="about-slider">
                <Flickity
                    className={'carousel'} // default ''
                    elementType={'div'} // default 'div'
                    options={flickityOptions} // takes flickity options {}
                    disableImagesLoaded={false} // default false
                >
                    <div className="slide">
                        <img src="https://images.pexels.com/photos/453201/pexels-photo-453201.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" />
                    </div>
                    <div className="slide">
                        <img src="https://images.pexels.com/photos/1082355/pexels-photo-1082355.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" />
                    </div>
                    <div className="slide">
                        <img src="https://images.pexels.com/photos/584399/living-room-couch-interior-room-584399.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" />
                    </div>
                    <div className="slide">
                        <img src="./assets/pexels-photo-1027512.jpeg" />
                    </div>
                </Flickity>
            </div>
        </div>
    )
}

export default AboutPage;
